import { render, staticRenderFns } from "./Unsubscribe.vue?vue&type=template&id=f36fc098&scoped=true&"
import script from "./Unsubscribe.vue?vue&type=script&lang=ts&"
export * from "./Unsubscribe.vue?vue&type=script&lang=ts&"
import style0 from "./Unsubscribe.vue?vue&type=style&index=0&id=f36fc098&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f36fc098",
  null
  
)

export default component.exports